import embed from '../embedReports/solarV2Embed';

// The slicers are driven entirely by the embed's event handlers
// (loaded, rendered, dataSelected, pageChanged).
const embedAndSlice = async (container, embedConfiguration) => {
  await embed.getEmbed(container, embedConfiguration);
};

export default {
  embedAndSlice,
};
